var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value && !_vm.tagMetricsLoading)?_c('Dashboard',{attrs:{"value":_vm.value,"tag-metric-values":_vm.tagMetricValues,"range-and-refresh":_vm.rangeAndRefresh,"tag-metrics-loading":_vm.tagMetricsLoading,"selected-filters":_vm.selectedFilters}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }